var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"OVERDUE TASKS","visible":_vm.dialog_visible,"width":"80%","lock-scroll":true,"close-on-click-modal":true,"close-on-press-escape":true,"show-close":true},on:{"update:visible":function($event){_vm.dialog_visible=$event}}},[_c('JobProposalsActionList',{attrs:{"title":"Tasks list","tasks_list":_vm.overdue_tasks}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }